<template>
    <div class="extra">
        <z-title title="额外项目设置" ref="title"></z-title>
        <el-card class="content1" ref="search">
            <div class="flex-n fac fjb">
                <el-input
                        size="medium"
                        class="ele-input mr-10"
                        maxlength="16"
                        placeholder="输入名称"
                        title="输入名称"
                        clearable
                        prefix-icon="el-icon-search"
                        v-model="itemName">
                </el-input>
            <div class="flex-n fac">
                <el-button type="primary" class="ele-btn2" @click="addExtra">新增</el-button>
                <el-upload
                        class="upload-demo"
                        ref="fileUpload"
                        action="#"
                        :http-request="httpRequest"
                        accept=".xlsx,.xls"
                        :show-file-list="false"
                        >
                    <el-button type="primary" class="ele-btn1 ml-10 mr-10" >导入额外项目</el-button>
                </el-upload>

                <el-button type="primary" class="ele-btn1" @click="editFenlei">编辑分类</el-button>
                <el-button type="primary" class="ele-btn2" @click="searchExtra">查询</el-button>

            </div>
            </div>
        </el-card>
        <el-card class="mt-10">
            <el-table
                    v-loading="loading"
                    :height="height+'px'"
                    highlight-current-row
                    element-loading-text="列表刷新中"
                    header-cell-class-name="headerrow"
                    cell-class-name="cellclass"
                    :data="dataList"
                    style="width: 100%">
                <el-table-column
                        prop="itemName"
                        fixed
                        label="名 称"
                        width="150"
                        align="center">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="itemTypeName"
                        label="分 类"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="itemPriceOld"
                        label="原 价"
                        width="150"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="itemPrice"
                        label="现 价"
                        width="150"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="remark"
                        label="备 注"
                        min-width="150"
                        align="center">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="130"
                        align="center">
                    <template slot-scope="scope">
                        <div style="margin: 5px 0">

                            <el-button type="primary" class="ele-btn-small mr-10" @click="editExtra(scope.row.id)">编辑</el-button>
                            <el-popconfirm
                                    title="确定删除该额外项目吗？"
                                    @confirm="delExtra(scope.row.id)"
                            >
                                <el-button slot="reference" type="primary" class="ele-btn-small">删除</el-button>
                            </el-popconfirm>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                        @currentChange="handleCurrentChange"></pagination>
        </el-card>
        <!--新增额外项目-->
        <el-dialog :visible.sync="showedit"
                   class="ele-toast" :close-on-click-modal="false">
            <div slot="title">
                <z-title :title="editstate+'额外项目'"></z-title>
            </div>
            <el-form :model="dataForm" :rules="rules" ref="ruleForm" class="rulefrom">
                <el-form-item label="名 称" prop="itemName" label-width="80px">
                    <el-input maxlength="16"  v-model="dataForm.itemName" placeholder="请输入额外项目名称"></el-input>
                </el-form-item>
                <el-form-item label="所属分类" prop="itemTypeCode" label-width="80px">
                    <div class="flex-n fjb fac">
                    <el-select  v-model="dataForm.itemTypeCode"  @visible-change="visiblechange" placeholder="请选择所属分类" style="width: 100%" class="mr-10">
                        <el-option
                                v-for="item in classifyList"
                                :key="item.itemTypeCode"
                                :label="item.itemTypeName"
                                :value="item.itemTypeCode">
                        </el-option>
                    </el-select>
                    <el-button type="primary" @click="editFenlei">编辑分类</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="原 价" prop="itemPriceOld" label-width="80px">
                    <el-input-number placeholder="请输入项目原价" v-model="dataForm.itemPriceOld" :precision="2" :step="0.1" controls-position="right"   :max="9999999999"></el-input-number>
                </el-form-item>
                <el-form-item label="现 价" prop="itemPrice" label-width="80px">
                    <el-input-number placeholder="请输入项目现价" v-model="dataForm.itemPrice" :precision="2" :step="0.1" controls-position="right"   :max="9999999999"></el-input-number>
                </el-form-item>
                <el-form-item label="备 注" prop="remark" label-width="80px">
                    <el-input type="textarea" rows="6" show-word-limit v-model="dataForm.remark" resize="none"
                              maxlength="512"></el-input>
                </el-form-item>
                <el-form-item class="mt-10 flex-n fje">
                    <el-button type="primary" @click="submitForm('ruleForm')">保 存</el-button>
                    <el-button @click="showedit = false">取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!--编辑分类-->
        <el-dialog :visible.sync="showfenlei" width="30%" top="20vh" :close-on-click-modal="false" class="editfenlei">
            <div slot="title" class="flex-n fac">
                <z-title title="编辑分类"></z-title>
                <el-button type="text" size="mini" @click="classify.typeList.push({itemTypeName:'',itemTypeCode:''})">添加</el-button>
            </div>

            <el-form :model="classify" :rules="rules" ref="ruleForm2" >
                <div class="tips">注意：如果分类下已经添加项目，则删除此分类，其分类下的所有项目也将一同删除</div>
                <el-form-item
                        v-for="(item, index) in classify.typeList"
                        label="分类名称"
                        :key="index"
                        :prop="'typeList.' + index + '.itemTypeName'"
                        :rules="{
      required: true, message: '分类名称不能为空', trigger: 'blur'
    }"
                >
                    <div class="flex-n fac fjb">
                        <el-input v-model="item.itemTypeName"  size="mini" class="mr-20"></el-input>
                        <!--<el-button type="primary" v-if="index==0" @click="classify.typeList.push({itemTypeName:'',itemTypeCode:''})" class="btn flex-n fac fjc"><i class="el-icon-plus"></i></el-button>-->
                        <el-button type="primary" @click="classify.typeList.splice(index,1)"  class="btn  flex-n fac fjc"><i class="el-icon-minus"></i></el-button>
                    </div>
                </el-form-item>
                <el-form-item class="mt-10 flex-n fje">
                    <el-button type="primary" @click="submitForm2('ruleForm2')">保 存</el-button>
                    <el-button @click="showfenlei = false">取 消</el-button>
                </el-form-item>

            </el-form>
        </el-dialog>

    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import Pagination from "../../components/pagination/pagination";

    export default {
        components: {
            Pagination,
            ZTitle},
        name: "extra",
        data() {
            return {
                loading: false,
                pageSize: 20,
                currentPage: 1,
                total: 0,
                height: 250,
                dataForm: {
                    itemTypeCode:''
                },
                editstate: '新增',
                showedit: false,

                dataList: [],
                fileList:[],

                itemName: '',
                id:'',

                classifyList:[],
                showfenlei:false,

                classify:{
                    typeList:[]
                },

                rules: {
                    itemName:[{ required: true, message: '名称不能为空', trigger: 'blur'}],
                    itemTypeCode:[{ required: true, message: '所属分类不能为空', trigger: 'change'}],
                    itemPrice: [{ required: true, message: '现价不能为空', trigger: 'blur'}],
                },
            }
        },
        mounted(){
            setTimeout(()=>{
                this.height=document.body.offsetHeight -this.$refs.title.$el.offsetHeight-this.$refs.search.$el.offsetHeight - 200;
                console.log(this.height)
            },0)
            this.getExList();
            this.getClassifyList();
        },
        watch:{
            showfenlei(newval,oldval){
                if(!newval){
                    this.$refs.ruleForm2.resetFields();
                    this.classify={
                        typeList:[]
                    }
                }
            },
            showedit(newval,oldval){
                if(!newval){
                    this.dataForm={
                        itemTypeCode:''
                    };
                    this.$refs.ruleForm.resetFields();
                }
            }
        },
        methods: {
            //查询额外项目列表
            getExList(){
                this.loading=true;
              this.$axios.post('/itemsEx/itemsExList',{
                  "storeId": this.$root.getStorage('storeId'),
                  "itemName": this.itemName,
                  "currentPage":this.currentPage,
                  "pageSize":this.pageSize,
              }).then(res=>{
                  console.log('额外项目列表', res);
                  this.dataList=res.data.list;
                  this.total = res.data.total;
                  this.loading=false;
              }).catch(err=>{
                  this.$message.error(err.msg);
                  this.loading=false;
              })
            },
            searchExtra(){
                this.currentPage=1;
                this.getExList();
            },
            getClassifyList(){
                this.$axios.post('/itemsEx/itemsExTypeListByStoreId',{
                    "storeId": this.$root.getStorage('storeId')
                }).then(res=>{
                    console.log('额外项目类型下拉列表',res)
                    this.classifyList=res.data.list;
                    if(this.showfenlei){
                        if(res.data.total==0){
                            this.classify.typeList=[{itemTypeName:'',itemTypeCode:''}]
                        }else{
                            this.classify.typeList=[].concat(res.data.list)
                        }
                    }
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            //查看分类列表
            visiblechange(isshow) {
                if (isshow) {
                    this.getClassifyList();
                }
            },

            editFenlei(){
                this.showfenlei=true;
                this.getClassifyList();
            },
            addExtra() {
                this.showedit = true;
                this.editstate = '新增'
            },
            editExtra(id) {
                console.log('编辑',id)
                this.id=id;
                this.showedit = true;
                this.editstate = '编辑';
                this.$axios.get('/itemsEx/itemsExById/'+id).then(res=>{
                    console.log(res)
                    this.dataForm=res.data;
                     // if(!res.data.itemPrice){
                     //     this.$set(this.dataForm,'',null)
                     // }
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            //删除
            delExtra(id){
                this.$axios.post('/itemsEx/itemsExDeleteByIds',id).then(res=>{
                    this.$message.success('删除额外项目成功！');
                    this.getExList();
                }).catch(err=>{
                    this.$message.error(err.msg);
                })

            },
            //添加提交
            addSubmit(){
                let {itemName,itemTypeCode,itemPriceOld,itemPrice,remark}=this.dataForm;
                this.$axios.post('/itemsEx/itemsExAdd',{
                    "storeId": this.$root.getStorage('storeId'),
                    "itemName": itemName,
                    "itemTypeCode": itemTypeCode,
                    "itemPriceOld": itemPriceOld,
                    "itemPrice":itemPrice,
                    "remark": remark
                }).then(res=>{
                    this.currentPage = 1;
                    this.getExList();
                    this.$message.success('新增额外项目成功！');
                    this.showedit = false;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            //编辑提交
            editSubmit(){
                let {itemName,itemTypeCode,itemPriceOld,itemPrice,remark}=this.dataForm;
                this.$axios.post('/itemsEx/itemsExUpdate',{
                    "storeId": this.$root.getStorage('storeId'),
                    "id":this.id,
                    "itemName": itemName,
                    "itemTypeCode": itemTypeCode,
                    "itemPriceOld": itemPriceOld,
                    "itemPrice":itemPrice,
                    "remark": remark
                }).then(res=>{
                    this.$message.success('编辑额外项目成功！');
                    this.getExList();
                    this.showedit = false;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            //验证表单
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.editstate == '新增'){
                            this.addSubmit();
                        }else{
                            this.editSubmit();
                        }
                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });
            },
            //验证表单2
            submitForm2(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var typeList=[];
                        console.log(this.classify.typeList)
                        for(var i=0;i<this.classify.typeList.length;i++ ){
                            typeList.push({'typeName':this.classify.typeList[i].itemTypeName,'id':this.classify.typeList[i].itemTypeCode})
                        }
                       this.$axios.post('/itemsExType/itemsExTypeUpdate',{
                           "storeId": this.$root.getStorage('storeId'),
                           "typeList":typeList
                       }).then(res=>{
                           this.$message.success('编辑分类成功！');
                           this.dataForm.itemTypeCode='';
                           this.showfenlei = false;
                           this.searchExtra();
                       }).catch(err=>{
                           this.$message.error(err.msg);
                       })
                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });
            },
            httpRequest(file) {
                console.log(file)
                var fileData=file.file;
                var msg = fileData.name.substring(fileData.name.lastIndexOf('.') + 1)
                //判断文件格式
                if (!(msg === 'xlsx' || msg === 'xls')) {
                    this.$refs.fileUpload.clearFiles()
                    this.$notify.error({
                        title: '错误',
                        message: '上传文件只能是 xlsx,xls格式!',
                        duration: 2000
                    })
                    return
                }
                let formData = new FormData();
                formData.append('file', fileData);
                formData.append('type', 1)
                this.$axios.post('/importExcel/uploadExItemsExcel', formData).then(res => {
                    console.log(res)
                    this.$message.success('附件上传成功');
                    this.searchExtra();
                }).catch(err => {
                    this.$message.success('附件上传失败')
                })
            },
            handleSizeChange(val) {
                this.pageSize=val;
                this.getExList();
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage=val;
                this.getExList();
                console.log(`当前页: ${val}`);
            },
        },
    }
</script>

<style scoped lang="scss">
    .extra {
        .content1 {
            .textnowrap {
                font-size: 13px;
                color: #333;
            }
            .date {
                min-width: 100px;
            }
        }
        .editfenlei{
            padding: 0 20px!important;
            .tips{
                font-size: 12px;
                color: #F56C6C;
            }
            .btn{
                padding: 0!important;
                width: 28px;
                min-width: 28px;
                height: 28px;
                font-size: 20px;
                font-weight: bold;
            }
        }
    }
</style>